import { Box, Typography } from '@mui/material';

import { ICurrentMonthStats } from 'src/types';
import { fCurrency, fPercent } from 'src/utils/format-number';
import { useLocales } from 'src/locales';

type Props = {
  currentMonthData: ICurrentMonthStats;
};

export default function MonthlyStatsCards({ currentMonthData }: Props) {
  const { t, currentLang } = useLocales('operativaDashboard');

  const cards = [
    {
      key: 'ordini_ricevuti',
      label: t('ordini_ricevuti'),
      value: currentMonthData.ordersReceived ?? 0,
    },
    {
      key: 'ordini_spediti',
      label: t('ordini_spediti'),
      value: currentMonthData.ordersShipped ?? 0,
    },
    {
      key: 'bottiglie',
      label: t('bottiglie'),
      value: currentMonthData.totalBottlesSold ?? 0,
    },
    {
      key: 'ricavi',
      label: t('ricavi'),
      value: fCurrency(currentMonthData.totalRevenue?.toFixed(2) ?? '0', currentLang.value),
    },
    {
      key: 'margine',
      label: t('margine'),
      value: fCurrency(currentMonthData.totalMargin?.toFixed(2) ?? '0', currentLang.value),
    },
    {
      key: 'margine_percentuale',
      label: t('margine_percentuale'),
      value: fPercent(currentMonthData.marginPercentage?.toFixed(2) ?? '0'),
    },
  ];

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: 'repeat(2, 1fr)',
          sm: 'repeat(3, 1fr)',
          md: 'repeat(6, 1fr)',
        },
        gap: 1.5,
      }}
    >
      {cards.map((card) => (
        <Box
          key={card.key}
          sx={{
            backgroundColor: 'background.neutral',
            borderRadius: 1,
            p: 3,
          }}
        >
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            {card.label}
          </Typography>
          <Typography variant="h4" sx={{ fontWeight: 'fontWeightMedium' }}>
            {card.value}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
